<template>

    <div class="tag">
        <div class="d-flex align-items-center">
            <v-swatch v-if="color" class="mr-5" :color="color" :size="10" :radius="5" />
            <slot></slot>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .tag {
        @include font-medium(12px);
        border: 1px solid $color-rule;
        border-radius: 3px;
        color: $color-text;
        display: inline-block;
        margin: 0 5px 5px 0;
        padding: 5px 10px;
        a {
            color: $color-text;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }

</style>

<script>

export default {

    props: {
        color: {
            type: String,
        },
    },

}

</script>
